<template>
  <v-container class="py-10 py-md-13 py-lg-16 item">
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" lg="7">
        <TitleWidget class="text-center text-sm-left">Fale Conosco</TitleWidget>

        <div
          class="
            grey--text
            text--darken-1 text-body-2 text-center text-sm-left
            mt-12
            item-subtitle
          "
        >
          Preencha os dados abaixo e nos envie uma mensagem
        </div>

        <ContactForm
          class="mt-6"
          :action="files + formAction"
          response-to="/fale-conosco/obrigado"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ContactForm from "../forms/ContactForm.vue";
import TitleWidget from "../widgets/TitleWidget.vue";

export default {
  data: () => ({
    formAction: "/rest/email/contact-us",
  }),
  components: {
    TitleWidget,
    ContactForm,
  },
};
</script>
